<template>
  <!-- 文字提示 -->
  <div id="textToast" :style="'display:' + porwhide">
    <div class="weui-mask_transparent"></div>
    <div class="weui-toast weui-toast_text" style="z-index: 10001;">
      <p class="weui-toast__content">网络不佳,请稍后重试</p>
    </div>
  </div>
</template>


<script>
export default {
  data () {
    return{
      netwstus: 0,
      porwhide: 'none'
    }
  },
  watch: {
    netwstus: function(val){
      if(val == 1){
        this.porwhide = 'block';
        const _this = this;
        setTimeout(function(){
          _this.porwhide = 'none';
        },1800)
      }
    }
  },
  created () {
    this.netwstus = window.plus.networkinfo.getCurrentType();
  }
}
</script>